import { render, staticRenderFns } from "./ExemptionList.vue?vue&type=template&id=19221d8c&scoped=true"
import script from "./ExemptionList.vue?vue&type=script&lang=js"
export * from "./ExemptionList.vue?vue&type=script&lang=js"
import style0 from "./ExemptionList.vue?vue&type=style&index=0&id=19221d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19221d8c",
  null
  
)

export default component.exports